module.exports = __webpack_public_path__ + "static/media/insta-13.299e58e0.png";